// Valores por defecto de pictogramsSga.
export const defaultPictogramsSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionPictogram = () => {
    return "";
};

// Valor por defecto de pictogram.
export const defaultPictogram = () => {
    return {
        id: null,
        name: null,
        image: null,
        imageBase64: null,
    };
};

// Valores por defecto de filterPictogramsSga.
export const defaultFilterSgaPictograms = () => {
    return {
        name: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activePictograms.
export const defaultActivePictograms = () => {
    return [];
};

export default {
    pictogramsSga: defaultPictogramsSga(),
    action: defaultActionPictogram(),
    pictogram: defaultPictogram(),
    filterPictogramsSga: defaultFilterSgaPictograms(),
    activePictograms: defaultActivePictograms(),
};
